import { useBackofficeMetrics } from '@/hooks/backoffice/useBackofficeMetrics'

function MetricCard({ label, value, hint }: { readonly label: string; readonly value: number | string; readonly hint?: string }) {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-foreground">{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  )
}

export function BackofficeOverviewPage() {
  const { data, isLoading } = useBackofficeMetrics()

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-foreground">Visão geral</h1>
        <p className="text-sm text-muted-foreground">Métricas da plataforma.</p>
      </div>

      {isLoading || !data ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          <MetricCard label="Transportadoras ativas" value={data.tenantsActive} hint={`Total: ${data.tenantsTotal}`} />
          <MetricCard label="Usuários ativos" value={data.usersActive} hint={`Total: ${data.usersTotal}`} />
          <MetricCard label="Pedidos de reset pendentes" value={data.pendingResetRequests} />
          <MetricCard label="Fretes nos últimos 30 dias" value={data.freightsLast30d} />
          <MetricCard label="Faturas pagas (30d)" value={data.invoicesPaidLast30d} />
        </div>
      )}
    </div>
  )
}
